// extracted by mini-css-extract-plugin
export default {"root":"Login_root_sGbhj","mainContentWrapper":"Login_mainContentWrapper_MXyzq","title":"Login_title_UVrZR","subtitle":"Login_subtitle_QAaBg","copyright":"Login_copyright_yRDJK"};